// Generate reconciliation
export const GENERATE_RECONCILIATION_REQUEST =
  'reconciliation/generate-request';
export const GENERATE_RECONCILIATION_PAGE_SUCCESS =
  'reconciliation/generate-page-success';
export const GENERATE_RECONCILIATION_COMPLETE =
  'reconciliation/generate-complete';
export const GENERATE_RECONCILIATION_FAILURE =
  'reconciliation/generate-failure';
export const GENERATE_RECONCILIATION_IN_PROGRESS =
  'reconciliation/generate-in-progress';
export const GENERATE_RECONCILIATION_RETRY_AFTER =
  'reconciliation/generate-retry-after';

// Query reconciliation (paginated results from cache)
export const QUERY_RECONCILIATION_REQUEST = 'reconciliation/query-request';
export const QUERY_RECONCILIATION_SUCCESS = 'reconciliation/query-success';
export const QUERY_RECONCILIATION_FAILURE = 'reconciliation/query-failure';

// Load reconciliation header
export const LOAD_RECONCILIATION_HEADER_REQUEST =
  'reconciliation/load-header-request';
export const LOAD_RECONCILIATION_HEADER_SUCCESS =
  'reconciliation/load-header-success';
export const LOAD_RECONCILIATION_HEADER_FAILURE =
  'reconciliation/load-header-failure';

// Load reconciliation transactions
export const LOAD_RECONCILIATION_TRANSACTIONS_REQUEST =
  'reconciliation/load-transactions-request';
export const LOAD_RECONCILIATION_TRANSACTIONS_SUCCESS =
  'reconciliation/load-transactions-success';
export const LOAD_RECONCILIATION_TRANSACTIONS_FAILURE =
  'reconciliation/load-transactions-failure';

// View saved reconciliation report
export const VIEW_RECONCILIATION_REPORT_REQUEST =
  'reconciliation/view-report-request';
export const VIEW_RECONCILIATION_REPORT_PAGE_SUCCESS =
  'reconciliation/view-report-page-success';
export const VIEW_RECONCILIATION_REPORT_COMPLETE =
  'reconciliation/view-report-complete';
export const VIEW_RECONCILIATION_REPORT_FAILURE =
  'reconciliation/view-report-failure';

// Filters
export const FETCH_RECONCILIATION_FILTERS_REQUEST =
  'reconciliation/fetch-filters-request';
export const FETCH_RECONCILIATION_FILTERS_SUCCESS =
  'reconciliation/fetch-filters-success';
export const FETCH_RECONCILIATION_FILTERS_FAILURE =
  'reconciliation/fetch-filters-failure';

// Reconciliation logs
export const FETCH_RECONCILIATION_LOGS_REQUEST =
  'reconciliation/fetch-logs-request';
export const FETCH_RECONCILIATION_LOGS_SUCCESS =
  'reconciliation/fetch-logs-success';
export const FETCH_RECONCILIATION_LOGS_FAILURE =
  'reconciliation/fetch-logs-failure';

// Save reconciliation report
export const SAVE_RECONCILIATION_REPORT_REQUEST =
  'reconciliation/save-report-request';
export const SAVE_RECONCILIATION_REPORT_SUCCESS =
  'reconciliation/save-report-success';
export const SAVE_RECONCILIATION_REPORT_FAILURE =
  'reconciliation/save-report-failure';

// Reset
export const RESET_RECONCILIATION = 'reconciliation/reset';

// ── Update organisation tax balance b/f ─────────────────────────────────
export const UPDATE_ORGANISATION_TAX_BALANCE_REQUEST =
  'reconciliation/update-organisation-tax-balance-request';
export const UPDATE_ORGANISATION_TAX_BALANCE_SUCCESS =
  'reconciliation/update-organisation-tax-balance-success';
export const UPDATE_ORGANISATION_TAX_BALANCE_FAILURE =
  'reconciliation/update-organisation-tax-balance-failure';
